import { errorToast } from "../../Utils/utils";
import { createAnonymAccountWithCode } from "./createAnonymAccounts";

export function loadCodeActivator(){
    listeners()

    $("#create-anonym-account").on("click", function(){
        const nickname = $("#nickname").val().toString();
        const code = $("#activation-code").val().toString()
        const password = $("#an-password").val().toString()
        const securityQuestion = Number($("#security-question").val())
        const answer = $("#security-answer").val().toString()

        if (nickname.split(" ").length > 1){
            errorToast("Dein Spitzname wird zum Einloggen benutzt und darf deshalb keine Leerzeichen enthalten")
            return
        }

        const re = /^[a-zA-Z0-9_.-]*$/;

        if (!re.test(nickname)){
            errorToast("Es dürfen nur Buchstaben, Zahlen und die Zeichen: _.- verwendet werden")
        }

        createAnonymAccountWithCode(nickname, code, password, securityQuestion, answer, $(this))
    })
}

function listeners(){
    $("#anonym-registration").on("click", function(){
        $("#activation-front").slideUp();
        $("#anonym-activation").fadeIn();
    });
    $("#anonym-activation-back").on("click", function(){
        $("#anonym-activation").slideUp();
        $("#activation-front").fadeIn();
    })
}